<template>
  <WsRead
    titleKey="name"
    :modelName="modelName"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :modeVersions="modeVersions"
    :customBtns="_customBtns"
    :isFetchData="isFetchData"
    :isPostVersion="_isPostVersion"
    @input="$_getModelData($event)"
    @createTemplateVersion="$_onOpenAlert('create')"
    @releaseTemplateVersion="$_onOpenAlert('release')"
  >
    <WsAlertDialog
      ref="createVersionAlertDialog"
      :title="alertTitle"
      :description="alertDescription"
      :btnText="btnText"
      @submit="$_onSubmitVersion()"
    />
  </WsRead>
</template>

<script>
import model from "@/models/license_template";
import S_base from '@/services/wasaapi/__base';

export default {
  data: () => ({
    modelName: model.modelName,
    versionModelName: model.versionModelName,
    modeVersions: true,
    label: model.label,
    localeMode: true,
    fields: model.fields,
    alertTitle: "",
    alertDescription: "",
    btnText: "",
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          hideOnNull: false,
          floors: [
            {
              fields: [
                "last_version.locales",
                "last_version.statitory_extension_period",
                "last_version.recommend_notify_period",
                "last_version.training_hours",
                "last_version.acts",
              ],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: [
                "sequence",
                "areas",
                "industry_categories",
                "system_classes",
                "system_subclasses",
                "license_type",
                "range_type",
                "factories",
                "exclusive_factories",
              ],
            },
          ],
        },
        {
          type: "select",
          title: "啟用",
          remark: "隱藏的內容將不會顯示於前端",
          field: "status",
        },
      ],
    },
    modelVersionData: {},
    isFetchData: false,
    modelData: {},
  }),
  computed: {
    _customBtns() {
      return [
        {
          title: `更新版本`,
          color: "textSecondary",
          outlined: true,
          icon: "mdi-update",
          emit: "createTemplateVersion",
          checkDisplayOnModelData: (modelData) => {
            return modelData.last_version.version_status === 1;
          },
        },
        {
          title: "發布新版本",
          color: "textSecondary",
          outlined: true,
          icon: "mdi-update",
          emit: "releaseTemplateVersion",
          checkDisplayOnModelData: (modelData) => {
            return modelData.last_version.version_status === 0;
          },
        },
      ];
    },
    _isPostVersion() {
      return this.modelData &&
      this.modelData.last_version &&
      !this.modelData.last_version.version_status;
    },
  },
  methods: {
    async $_getModelVersionData(modelData) {
      try {
        const getUrl = `/${this.versionModelName}/${modelData.last_version.id}`;
        const res = await this.$axios.get(getUrl);
        return res.data.data;
      } catch (error) {
        alert(error);
      }
    },
    $_onOpenAlert(type) {
      this.alertTitle = type === 'create' ? '更新版本' : '發布新版本';
      this.alertDescription = type === 'create' ? '確定要建立一個新的公版版本嗎？' : '確定要發布新版本嗎？';
      this.btnText = "確認";
      this.$refs.createVersionAlertDialog.open();
    },
    async $_onSubmitVersion() {
      this.$refs.createVersionAlertDialog.startLoading();
      this.modelVersionData = await this.$_getModelVersionData(this.modelData);
      const {version_status: versionStatus, id} = this.modelVersionData;
      const createData = this.$_setCreateData(this.modelVersionData);
      try {
        if (versionStatus === 1) {
          await this.$axios.post(`/${this.modelName}/${this.$route.params.id}/${this.versionModelName}/`, createData);
        } else {
          await this.$axios.put(`/${this.versionModelName}/${id}`, createData)
        }
        await S_base.update({
          modelName: this.modelName,
          modelId: this.$route.params.id,
          payload: {status: versionStatus === 1 ? 2 : 1},
        });
      } catch (error) {
        alert(error);
      }
      this.isFetchData = !this.isFetchData;
      this.$refs.createVersionAlertDialog.close();
      this.$refs.createVersionAlertDialog.stopLoading();
    },
    $_getModelData($event) {
      this.modelData = $event;
    },
    $_setCreateData(modelVersionData) {
      const {
        training_hours,
        statitory_extension_period,
        recommend_notify_period,
        article_versions,
        act_version_alls,
        locales,
        version_status: versionStatus
      } = modelVersionData;
      const { actVersionAlls, articleVersions } = this.$_CMS_setArticleAndActPostData(article_versions, act_version_alls);
      return {
        version_status: versionStatus === 1 ? 0 : 1,
        training_hours,
        statitory_extension_period,
        recommend_notify_period,
        locales,
        article_versions: articleVersions,
        act_version_alls: actVersionAlls,
      };
    },
  },
};
</script>